export default function getAppName(): undefined | string {
  // @ts-ignore - No bender type in the hubspot window object yet
  return window?.hubspot?.bender?.currentProject ?? undefined;
}
